"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAssetIdentities = void 0;
exports.getOrganizationIdentities = getOrganizationIdentities;
exports.shareAsset = shareAsset;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _IdentityService = _interopRequireDefault(require("@mulesoft/exchange-api-client/lib/IdentityService"));
var _actionify = _interopRequireDefault(require("../../utils/actionify"));
var sessionSelectors = _interopRequireWildcard(require("../session/selectors"));
var assetsSelectors = _interopRequireWildcard(require("../assets/selectors"));
var events = _interopRequireWildcard(require("./events"));
var actions = _interopRequireWildcard(require("./actionTypes"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/** Gets the identities for an asset an the roles that they have assigned */
var getAssetIdentities = exports.getAssetIdentities = (0, _actionify.default)(_IdentityService.default, function (service) {
  return service.list;
}, actions.GET_IDENTITIES);

/** Gets the available identities for the organization */
function getOrganizationIdentities(_ref) {
  var organizationId = _ref.organizationId,
    query = _ref.query;
  return function (dispatch, getState, _ref2) {
    var config = _ref2.config;
    var state = getState();
    var context = sessionSelectors.context(state);
    var identityService = new _IdentityService.default(config);
    return identityService.listOrganizationIdentities({
      organizationId: organizationId,
      query: query,
      context: context
    });
  };
}
var getOrganizationId = function getOrganizationId(identity) {
  var _identity$organizatio;
  return ['organization', 'externalOrganization'].some(function (type) {
    return identity.identityType === type;
  }) ? identity.id : (_identity$organizatio = identity.organization) === null || _identity$organizatio === void 0 ? void 0 : _identity$organizatio.id;
};
var updateIdentities = (0, _actionify.default)(_IdentityService.default, function (service) {
  return service.update;
}, actions.UPDATE_IDENTITIES);

/** Shares an asset with given identities */
function shareAsset(_ref3) {
  var groupId = _ref3.groupId,
    assetId = _ref3.assetId,
    identities = _ref3.identities,
    trackEvent = _ref3.trackEvent;
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(dispatch, getState) {
      var state, asset, added, deleted, roles;
      return _regenerator.default.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            asset = assetsSelectors.asset(state, {
              groupId: groupId,
              assetId: assetId
            });
            added = identities.filter(function (identity) {
              return identity.isNewIdentity || identity.updatedRole;
            }).map(function (identity) {
              var _identity$updatedRole;
              return {
                identityId: identity.id,
                role: ((_identity$updatedRole = identity.updatedRole) === null || _identity$updatedRole === void 0 ? void 0 : _identity$updatedRole.id) || identity.role.id,
                identityType: identity.identityType,
                organizationId: getOrganizationId(identity)
              };
            });
            deleted = identities.filter(function (identity) {
              return identity.isMarkedAsDeleted || identity.updatedRole;
            }).map(function (identity) {
              return {
                identityId: identity.id,
                role: identity.role.id,
                identityType: identity.identityType,
                organizationId: getOrganizationId(identity)
              };
            });
            roles = {
              added: added,
              deleted: deleted
            };
            _context.next = 1;
            return dispatch(updateIdentities({
              groupId: groupId,
              assetId: assetId,
              roles: roles
            }));
          case 1:
            trackEvent(events.USERS_PERMISSIONS_UPDATED, {
              type: asset.type,
              granted: roles.added.map(function (_ref5) {
                var identityType = _ref5.identityType,
                  role = _ref5.role;
                return "".concat(identityType, ":").concat(role);
              }),
              revoked: roles.deleted.map(function (_ref6) {
                var identityType = _ref6.identityType,
                  role = _ref6.role;
                return "".concat(identityType, ":").concat(role);
              }),
              totalUpdates: roles.added.length + roles.deleted.length
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();
}
//# sourceMappingURL=actions.js.map